/* global axios */
import ApiClient from './ApiClient';

// Nested form-responses on a tramite: list/show pending+submitted formularios, ad-hoc dispatch,
// and submit filled answers. Mirrors tramiteDocumentRequests.
class TramiteFormResponsesAPI extends ApiClient {
  constructor() {
    super('tramites', { accountScoped: true });
  }

  get(tramiteId) {
    return axios.get(`${this.url}/${tramiteId}/form_responses`);
  }

  show(tramiteId, id) {
    return axios.get(`${this.url}/${tramiteId}/form_responses/${id}`);
  }

  dispatch(tramiteId, tramiteTypeFormId) {
    return axios.post(`${this.url}/${tramiteId}/form_responses`, {
      tramite_type_form_id: tramiteTypeFormId,
    });
  }

  submit(tramiteId, id, values) {
    return axios.post(`${this.url}/${tramiteId}/form_responses/${id}/submit`, {
      values,
    });
  }
}

export default new TramiteFormResponsesAPI();
